"use client";

import { TextResources } from "@portal/assets/text/TextResources";
import StatusBar from "@portal/components/atoms/statusBar";
import Typography from "@portal/components/atoms/v2/typography";
import useSelectedUserPoaForLoggedInUser from "@portal/hooks/useSelectedUserPoaForLoggedInUser";
import { PowerOfAttorneyType } from "@portal/types/api/IPoaInfo";
import { useMemo } from "react";

const AmlStatusMessage = () => {
  const { data: poa, selectedUser, isLoading } = useSelectedUserPoaForLoggedInUser();

  const hasAnyPortfolioWithFullAccess = useMemo(() => {
    return poa?.some(
      p =>
        p.customerNumber === selectedUser?.userId &&
        p.portfolios.some(
          po => po.powerOfAttorneyType === PowerOfAttorneyType.Full || po.powerOfAttorneyType === PowerOfAttorneyType.Child,
        ),
    );
  }, [poa, selectedUser?.userId]);

  if (!selectedUser?.userId || hasAnyPortfolioWithFullAccess || isLoading) {
    return null;
  }

  return (
    <div className="print:hidden">
      <StatusBar>
        <div className="flex">
          <Typography variant="Body">{TextResources.LIMITED_ACCESS_AT_SELECTED_USER}</Typography>
        </div>
      </StatusBar>
    </div>
  );
};

export default AmlStatusMessage;
